import {
  AccommodationType,
  TransportationMode,
} from '@/domain/impact-co2/entities/question.entity';

export type ImpactCo2AnswerStatsPublic = {
  publicMobility: {
    transportationMode: TransportationMode;
    totalPassengerCount: number;
    totalTravelDistance: number;
    totalScore: number;
  }[];
  publicAccommodation: {
    accommodationType: AccommodationType;
    totalGuestCount: number;
    totalNumberOfNights: number;
    totalScore: number;
  }[];
  averageNumberOfNights: number;
  numberOfNights: number;
  publicMobilityTotalReplies: number;
  publicMobilitySumTotalTravelDistance: number;
  publicMobilitySumTotalPassengerCount: number;
  publicAccommodationTotalReplies: number;
  publicAccommodationSumTotalGuestCount: number;
};

export const EMPTY_IMPACT_STATS_PUBLIC = {
  publicMobility: [],
  publicAccommodation: [],
  averageNumberOfNights: 0,
  numberOfNights: 0,
  publicMobilityTotalReplies: 0,
  publicMobilitySumTotalTravelDistance: 0,
  publicMobilitySumTotalPassengerCount: 0,
  publicAccommodationTotalReplies: 0,
  publicAccommodationSumTotalGuestCount: 0,
};
